import 'flickity/dist/flickity.pkgd.js';
import Flickity from 'flickity';
import 'viewerjs/dist/viewer.min.js';
import 'jquery-viewer/dist/jquery-viewer.min.js';

import { cookieConsent } from './scripts/cookie/cookieConsent';
import { deleteCookie } from './scripts/cookie/deleteCookie';
import { fullWidthVideoPlayerFile } from './scripts/video/fullWidthVideoPlayerFile';
import { videoPopupPlayerFile } from './scripts/video/videoPopupPlayerFile';
import { delayHomeBannerVideoFile } from './scripts/video/delayHomeBannerVideoFile';
import { headerScripts } from './scripts/header/headerScripts';
import { stickyMenu } from './scripts/header/stickyMenu';
import { loadMore } from './scripts/load-more/loadMore';
import { formScripts } from './scripts/form/formScripts';
import { cardSectionGridSlider } from './scripts/card/cardSectionGridSlider';
import { cardSectionSlider } from './scripts/card/cardSectionSlider';
import { logoSlider } from './scripts/logo/logoSlider';
import { logoSectionGridSlider } from './scripts/logo/logoSectionGridSlider';
import { gallerySectionSlider } from './scripts/gallery/gallerySectionSlider';
import { jqueryViewer } from './scripts/gallery/jqueryViewer';
import { editorContentAdditions } from './scripts/misc/editorContentAdditions';
import { testimonialSlider } from './scripts/testimonial/testimonialSlider';
import { testimonialGridSlider } from './scripts/testimonial/testimonialGridSlider';

// Flickity.prototype._createResizeClass = function() {
//   this.element.classList.add('flickity-resize');
// };

// Flickity.createMethods.push('_createResizeClass');

// var resize = Flickity.prototype.resize;
// Flickity.prototype.resize = function() {
//   this.element.classList.remove('flickity-resize');
//   resize.call( this );
//   this.element.classList.add('flickity-resize');
// };

export default {
  init() {
    // JavaScript to be fired on all pages
    Flickity.defaults.dragThreshold = 3;
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired

    logoSlider();
    cookieConsent();
    deleteCookie('PREF');
    headerScripts();
    stickyMenu();
    logoSectionGridSlider();
    formScripts();
    cardSectionGridSlider();
    cardSectionSlider();
    gallerySectionSlider();
    jqueryViewer('.gallery-images-viewer-v2');
    jqueryViewer('.gallery-images-viewer-v1');
    fullWidthVideoPlayerFile();
    videoPopupPlayerFile();
    delayHomeBannerVideoFile();
    editorContentAdditions();
    loadMore();
    testimonialGridSlider();
    testimonialSlider();
    slideUpMenuOption();
    buttonArrow();
    setupScrollWithOffset('card-wrap', '#footer-section', 25);
    onScrollToTop();
    setFullHeight();
  },
};

$(window).on('scroll', function () {
  onScrollToTop();
});

$(window).on('resize', function () {
  // flickity resize to work when specific amount of pizels are resized eg: now at 10px
  const resizeDelta = Math.abs($(window).width() - $(window).data('previousWidth'));

  if (resizeDelta > 10) {
    // $('.cards-section.slider .cards-wrp, .cards-section.grid .cards-wrp, .gallery-section.v1 .gallery-wrapper, .testimonials-section .testimonials-row'
    // ).flickity('resize');

    $('.flickity-viewport').css('height', '400');
  }

  setFullHeight();

  $(window).data('previousWidth', $(window).width());
  // flickity resize to work when specific amount of pizels are resized eg: now at 10px

  // set header height to sticky overlay
  $('.sticky-overlay').outerHeight($('.header').outerHeight());
  $('.main > section:first-child:not(".home-banner-section, .header-variation-active")').css('margin-top', $('.header').outerHeight());
});

$(window).on('load', function () {
  $('.cards-section.slider .cards-wrp, .cards-section.grid .cards-wrp, .gallery-section.v1 .gallery-wrapper, .testimonials-section .testimonials-row'
  ).flickity('resize');
});

function setFullHeight() {
  const viewportHeight = $(window).height();
  const viewportHeightNew = viewportHeight - 140;
  if (matchMedia('screen and (max-width: 575px)').matches) {
    $('.full-height').css('min-height', viewportHeightNew + 'px');
  } else {
    $('.full-height').css('min-height', viewportHeight - 180 + 'px');
  }
}

function onScrollToTop() {
  const $fixedDiv = $('body > .sticky-overlay');
  const $fixedDiv2 = $('body > .header');

  if (window.scrollY <= 30 || document.documentElement.scrollTop <= 30) {
      $fixedDiv.addClass('highlighted');
      $fixedDiv2.addClass('highlighted');
  } else {
    $fixedDiv.removeClass('highlighted');
    $fixedDiv2.removeClass('highlighted');
  }
}

// function footerTickerSlider() {
//   // Play with this value to change the speed
//   let tickerSpeed = 1;

//   let flickity = null;
//   let isPaused = false;
//   const slideshowEl = document.querySelector('.footer-ticker .ticker-wrp');

//   const update = () => {
//     if (isPaused) return;
//     if (flickity.slides) {
//       flickity.x = (flickity.x - tickerSpeed) % flickity.slideableWidth;
//       flickity.selectedIndex = flickity.dragEndRestingSelect();
//       flickity.updateSelectedSlide();
//       flickity.settle(flickity.x);
//     }
//     window.requestAnimationFrame(update);
//   };

//   const pause = () => {
//     isPaused = true;
//   };

//   const play = () => {
//     if (isPaused) {
//       isPaused = false;
//       window.requestAnimationFrame(update);
//     }
//   };

//   flickity = new Flickity(slideshowEl, {
//     autoPlay: false,
//     prevNextButtons: false,
//     pageDots: false,
//     draggable: true,
//     wrapAround: true,
//     selectedAttraction: 0.015,
//     friction: 0.25,
//   });

//   flickity.x = 0;

//   slideshowEl.addEventListener('mouseenter', pause, false);
//   slideshowEl.addEventListener('focusin', pause, false);
//   slideshowEl.addEventListener('mouseleave', play, false);
//   slideshowEl.addEventListener('focusout', play, false);

//   flickity.on('dragStart', () => {
//     isPaused = true;
//   });

//   update();
// }

function slideUpMenuOption() {
  if ($('body > .header').hasClass('enable-scroll-up')) {
    var lastScrollTop = 0, delta = 15;
    var bannerHeight = $('.header').outerHeight();
    $(window).scroll(function(){
      var st = $(this).scrollTop();

      if(Math.abs(lastScrollTop - st) <= delta)
        return;
      if ((st > lastScrollTop) && (lastScrollTop>0)) {
            // downscroll code
            $('body > .header, body > .sticky-overlay').css('top', (bannerHeight - (bannerHeight *2)));
      } else {
        // upscroll code
        $('body > .header, body > .sticky-overlay').css('top','0px');
      }
      lastScrollTop = st;
    });
  }
}

function buttonArrow() {
  $('.btn-read-more:not(.btn-with-arrow)').each(function() {
    $(this).html('<span>' + $(this).html() + '</span>');
    $(this).append('<span class="arrow-icon"></span>');
    $(this).addClass('btn-with-arrow');
    $(this).css({ display: 'flex' });
  });
}

function setupScrollWithOffset(triggerClass, targetSelector, offset = 0) {
  const triggerElements = document.querySelectorAll(`.${triggerClass}`);
  const targetElement = document.querySelector(targetSelector);

  if (triggerElements.length > 0 && targetElement) {
    triggerElements.forEach(triggerElement => {
      triggerElement.addEventListener('click', () => {
        const targetPosition = targetElement.getBoundingClientRect().top + window.scrollY;
        const offsetPosition = targetPosition - offset;

        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth',
        });
      });
    });
  }
}
